import { iPostData } from "../types/postData";
import { Inputs } from "../types/inputs";
import { iComp } from "../types/competition";

const { VITE_API_SERVER , VITE_EXPRESS_APISERVER, VITE_API_SERVER_IE, VITE_EXPRESS_APISERVER_IE} = import.meta.env

declare global {
    interface Window { siteVar: any; }
};
type Address = {
    suggestion: string;
    format: string;
};

export const fetchCompetitions = async (referer:string) => {
    try {
        const api = referer === 'IE' ? VITE_EXPRESS_APISERVER_IE : VITE_EXPRESS_APISERVER
        const url = `${api}/competitions`; 
        let res = await fetch(url)
        if(res) return res.json()
        else return []
    } catch (err) {
        throw new Error(`error fetching competitions | ${err}`)
    }   
}

export const submitEntry = async (data: Inputs, competition :iComp, referer:string) => {
    
    try {
        const api = referer === 'IE' ? VITE_EXPRESS_APISERVER_IE : VITE_EXPRESS_APISERVER
        const url = `${api}/competition/entry` 
        //buildup the data object
        if(data.selectedAddress){
            data.address1 = data.selectedAddress.split(',')[0]
            data.address2 = data.selectedAddress.split(',')[1] || ''
            data.address3 = data.selectedAddress.split(',')[2] || ''
        }
        data.key = competition._id
        data.title = data.title || ''
        data.address1 = data.address1 || ''
        data.address2 = data.address2 || ''
        data.address3 = data.address3 || ''
        data.postcode = data.postcode || ''
        data.telephone = data.telephone || ''
        data.company_name = data.company_name || ''
        data.job_title = data.job_title || ''
        data.field_of_business = data.field_of_business || ''
        data.created_date = new Date()
         
        let res = await fetch(url, {
            method : 'POST',
            headers: { 'Content-Type': 'application/json' },
            body : JSON.stringify(data)
        })
        if (res) return res.json()
        else return []
    } catch (err) {
        throw new Error(`error submitting competition entry | ${err}`)
    }
}

export const subscribeToMarketing = async (data: Inputs, socialCookies : string | false, referer : string) => {
    try {
        const api = referer === 'IE' ? VITE_API_SERVER_IE : VITE_API_SERVER
        const url = `${api}/client-marketing/subscribepost` 
        const postData = {} as iPostData;
                postData.mongoData = {
                    email : data.email,
                    title : data.title,
                    name : data.firstname,
                    surname : data.lastname,
                    source : 'web',
                    partition :  window.siteVar.referer,
                    SMID : socialCookies ? socialCookies : '',
                };
                postData.send_to = data.email;
                postData.version = "3";
                postData.ieBooking = window.siteVar.referer === 'IE' ? true : false;
                postData.email = data.email;
                postData.title = data.title;
                postData.firstname = data.firstname;
                postData.surname = data.lastname;
                postData.partition = window.siteVar.referer;
                postData.emailUI = true;
                postData.emailId = "1";
               
          
                const res = await fetch(url, {
                    method : 'post',
                    headers : {
                      "Content-Type" : "application/json"
                    },
                    body : JSON.stringify(postData)
                  }) 
                  let response = await res
                  if(response){
                    return response
                  }
    } catch (err) {
        throw new Error(`error posting to marketing database | ${err}`)
    } 
}

export const postCodeLookup = async (postcode : string, referer : string) => {
    //postcode address search
    const url = referer === 'IE' ?
     `${VITE_API_SERVER_IE}/address/eire/${postcode}` : `${VITE_API_SERVER}/address/${postcode}`
    if(postcode.length > 5){
        const data = await fetch(url);
        const formattedData = await data.json();
        if (formattedData && referer === 'UK'){
        let tmp:string[] = []
        formattedData.results.forEach((item: Address) => {
            tmp.push(item.suggestion.substring(1)) //remove 1st character as api returns blank space
        });
          return tmp;
        }else if(formattedData && referer === 'IE'){
            return formattedData
        }else return []
    }
  }
